import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NbToastrService} from '@nebular/theme';
import {Router} from '@angular/router';
import {AuthService} from '../../services/auth.service';
import swal from "sweetalert2";
import * as sha512 from 'js-sha512';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public user: any;
  login = true;
  recover = false;
  register = false;
  frmLogin: FormGroup;
  frmRecuperar: FormGroup;
  frmRegistrar: FormGroup;
  submitted = false;
  loading = false;

  constructor(public fb: FormBuilder , private toastrService: NbToastrService, public router: Router, public authService:AuthService) {
    this.frmLogin = this.fb.group({
      user: ["", [Validators.required]],
      pass: ["", [Validators.required]]
    });
    if (localStorage.user === undefined) {
      localStorage.setItem("user", JSON.stringify([]));
    }
  }

  get f() { return this.frmLogin.controls; }


  ngOnInit() {
  }

  showToast(position, status, titulo, mensaje) {
    this.toastrService.show(
      mensaje,
      titulo,
      { position, status });
  }

  verificacion(){
    if(this.frmLogin.value.usuario === '' || this.frmLogin.value.clave === ''){
      this.showToast(
        "top-right",
        "waring",
        "Error!",
        "Debe escribir el y usuario y contraseña!"
      );
    }else{
      this.router.navigate(["dashboard/home"]);
    }
  }
  OnIniciarSesion() {
    this.submitted = true;
    if (this.frmLogin.invalid) {
      return false;
    }
    this.loading= true;
    const data = {
      user: this.frmLogin.value.user,
      pass: sha512.sha512(this.frmLogin.value.pass)
    };
    console.log(data);
    this.authService.loginEmailUser(data).subscribe(result => {
      console.log(result);
      this.loading = false;
      if (result.error === 1) {
        swal.fire({
          icon: "error",
          title: "",
          text: result.msj
        });
      } else {
        delete result.user.password;
        localStorage.setItem("userOcelote", JSON.stringify(result.user));
        /*swal.fire({
          icon: "success",
          title: result.msj,
          text: result.user.name + " " + result.user.lastName,
        });
        
       const swalWithBootstrapButtons = swal.mixin({
        customClass: {
          confirmButton: 'btn btn-success',
        },
        buttonsStyling: false
      })
      
      swalWithBootstrapButtons.fire({
        icon: "success",
        title: result.msj,
        text: result.user.name + " " + result.user.lastName,
        showCancelButton: false,
        confirmButtonText: 'Ok',
        cancelButtonText: "No, cancel plx!",
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          //window.location.reload();
        }
      })*/
        this.onLoginRedirect();
      }
    });
  }
  onLoginRedirect(): void {
    this.router.navigate(["dashboard/home"]);
  }
}
